import { useQuery } from "@tanstack/react-query";

import { BreadcrumbsController } from "../../api/breadcrumbsController";

export function useMapSettings() {
	return useQuery({
		queryFn: () => BreadcrumbsController.getSettings(),
		queryKey: ["MapSettings"],
	});
}
